import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { SvgIconComponent } from 'angular-svg-icon';
@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule, NzModalModule, NzButtonModule, SvgIconComponent],
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent {
  @Input() isVisible = false;

  @Input() title = 'Confirm Action';
  @Input() iconSrc = '';
  @Input() iconColor = '';
  @Input() message = 'Are you sure you want to perform this action?';
  @Input() cancelText = '';
  @Input() confirmText = 'Confirm';
  @Input() primaryButtonClass = 'btn btn-cancel';
  @Input() width = '400px';
  @Input() loading = false;
  @Input() disableConfirm = false;
  @Input() hideFooter = false;

  @Input() messageTemplate?: TemplateRef<unknown>; // Allow custom message template
  @Input() footerTemplate?: TemplateRef<unknown>; // Allow custom footer template

  @Output() confirmed = new EventEmitter<void>(); // Renamed from confirm
  @Output() cancelled = new EventEmitter<void>(); // Renamed from onCancel
  @Output() closed = new EventEmitter<void>();

  handleConfirm(): void {
    this.confirmed.emit();
  }

  handleCancel(): void {
    this.cancelled.emit();
  }

  closeDialog(): void {
    this.closed.emit();
  }
}
